import { MSG_A01, MSG_A04, MSG_A11 } from 'services/utils/messages';

import * as Yup from 'yup';

export default Yup.object({
  subject: Yup.string(MSG_A11)
    .required(MSG_A01)
    .max(60, 'Máximo de 60 caracteres'),
  name: Yup.string(MSG_A11).max(60, 'Máximo de 60 caracteres'),
  email: Yup.string(MSG_A11).email(MSG_A04).required(MSG_A01),
  phone: Yup.string(MSG_A11),
  message: Yup.string(MSG_A11)
    .required(MSG_A01)
    .min(4, 'mínimo de 4 caracteres')
    .max(1000, 'Máximo de 1000 caracteres'),
});
